import { render } from "./SpreadsheetItem.vue?vue&type=template&id=786497a2&scoped=true&ts=true"
import script from "./SpreadsheetItem.vue?vue&type=script&lang=ts"
export * from "./SpreadsheetItem.vue?vue&type=script&lang=ts"

import "./SpreadsheetItem.vue?vue&type=style&index=0&id=786497a2&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786497a2"]])

export default __exports__